import moment from "moment";

export const monthList = () => {
    const months = [];
    const totalMonth = 12;
    for (let i = 1; i <= totalMonth; i++) {
        let value = moment().month(i - 1).format('MM');
        let label = moment().month(i - 1).format('MMM').toUpperCase();
        let name = moment().month(i - 1).format('MMMM');
        let totalDays = moment().month(name).daysInMonth();
        totalDays = Array.from({ length: totalDays }, (_, i) => ({value: String(i + 1).padStart(2, '0'), label: String(i + 1).padStart(2, '0')}) );
        months.push({ label, value, name, totalDays});
    }
    return months;
}

export const splitDate=(date)=>{
    if(date){
        const dateParts = moment(date, 'YYYY-MM-DD');
        const day = String(dateParts.date()).padStart(2, '0');
        const month = String(parseInt(dateParts.month()+1)).padStart(2, '0');
        return ({month: month, day: day});
    }else{
        return ({month: '', day: ''});
    }
}